<template>
  <div id="outrights-match">
    <header-menu :show-hours="false" />
    <sports-header
      :sports="sports"
      :limit="limit" />
    <div
      class="sport"
      :class="'sport-' + selectedSport.providerId"
    >
      <div
        class="back-button"
        v-go-back>
        <i class="n-i n-i-arrow-left"/>
      </div>
      {{ selectedSport ? selectedSport.name : '' }}
      \ {{ getTranslation('sportsbook.outrights_title') }}
      \ {{ selectedTournament ? selectedTournament.name : '' }}
    </div>

    <scroller v-if="matches">
      <div
        class="matches"
        v-max-height="{
          el: ['.header-menu', '.sports-header', '.footer', '.sport'],
          offset: 20
        }"
      >
        <div
          class="match"
          v-for="match in matches"
          :key="match.id">
          <div
            class="outrights"
            v-for="bet in match.bets"
            :key="bet.id">
            <div class="outcomes">
              <div class="bet-name">{{ match.name }}</div>
              <div
                class="outcome-outrights-wrapper"
                v-for="outcome in bet.outcomes"
                :key="outcome.idMatchBet">
                <div
                  class="outcome-outrights"
                  :class="{ active: addedToBetslip(outcome) }"
                  @click="addToBetslip(match, bet, outcome)">
                  <div class="outcome-name">{{ outcome.name }}</div>
                  <div class="outcome-value">{{ outcome.display[oddType] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import Moment from 'moment';
import HeaderMenu from '../../shared/header-menu/HeaderMenu.vue';
import SportsHeader from '../../shared/sports-header/SportsHeader.vue';

export default {
  components: {
    HeaderMenu,
    SportsHeader,
  },
  computed: {
    oddType() {
      return this.$store.getters.getActiveOddType;
    },
    betslipBets() {
      return this.$store.getters.getBetslipBets;
    },
    selectedSport() {
      return this.$store.getters.getOutrightsSport(this.$route.params.sportId);
    },
    selectedTournament() {
      return this.$store.getters.getOutrightsTournament(this.$route.params.tournamentId);
    },
    sports() {
      return _.sortBy(this.$store.getters.getOutrightsSports, ['position']);
    },
    matches() {
      return this.$store.getters.getOutrightsMatches;
    },
    limit() {
      return this.$store.getters.getCompanyConfig.maxSports;
    },
  },
  mounted() {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const startDate = new Moment();
    this.$store.dispatch('fetchOutrights', {
      params:
      {
        id_tournament: this.$route.params.tournamentId,
        id_sport: this.$route.params.sportId,
        start_date: Moment.utc(startDate).format(dateFormat),
      },
    });
  },
  methods: {
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    addToBetslip(match, bet, outcome) {
      if (!outcome.value) return;

      const parsedBet = {
        key: outcome.idMatchBetOutcome,
        keyBet: bet.id,
        keyOutcome: outcome.idMatchBetOutcome,
        matchDisplayId: match.displayId,
        matchDateTimeUTC: match.timestampUTC,
        idMatchBet: bet.idMatchBet,
        matchId: match.id,
        title: match.name,
        subtitle: bet.name,
        outcome: outcome.name,
        oddValue: outcome.value,
        oddDisplay: outcome.display,
        specialValue: bet.specialValue,
        banker: false,
        change: null,
      };

      this.$store.dispatch('addBetToBetslip', parsedBet);
    },
    addedToBetslip(outcome) {
      return _.findIndex(this.betslipBets, { key: outcome.idMatchBetOutcome }) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/default/modules/outrights-tournament';
</style>
